<template>
    <div class="background-box">
        <div class="float-box">
            <chatComponent :width="chatWidth" :height="chatHeight" ref="chatIframeComponent" />
            <el-button type="danger" :icon="Close" circle size="large" @click="clickCloseBtn" class="close-chat-box-btn" />
        </div>
    </div>
</template>

<script setup>
    import chatComponent from "@/components/shopopee/chat/chatComponent"
    import { Close } from '@element-plus/icons-vue'
    import {onBeforeMount, ref, getCurrentInstance} from "vue";
    import myUtil from "@/util/util";

    const emits = defineEmits(["clickClose"])

    const { proxy } = getCurrentInstance()

    const chatWidth = ref("425px")
    const chatHeight = ref("425px")

    function openPersonChat(login){
        proxy.$refs.chatIframeComponent.openPersonChat(login)
    }

    function clickCloseBtn(){
        emits("clickClose")
    }

    onBeforeMount(() => {
        // chatWidth.value = myUtil.isMobile() ? `${Math.floor(window.innerWidth * 0.9 - 35)}px` : '900px'
        chatWidth.value = myUtil.isMobile() ? `${Math.floor(window.innerWidth * 0.9 - 35)}px` : '500px'
        chatHeight.value = myUtil.isMobile() ? `${Math.floor(window.innerHeight * 0.9)}px` : '675px'
    })

    defineExpose({
        openPersonChat
    })

</script>

<style scoped>
    .float-box {
        position: relative;
    }

    .close-chat-box-btn {
        position: absolute;
        top: -35px;
        right: -35px;
    }

    .background-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #00000033;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>